// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1BP5C","inputWrap":"CustomTip_inputWrap__1GpM-"};